import {
    CLINICAL_VA_NEEDED_STATUS_ID,
    DM_VA_NEEDED_STATUS_ID,
    MANUFACTURER_STATUS_STATUSES,
    PENDING_MONITORING_START_STATUS_ID,
    TREATMENT_IN_PROGRESS_STATUS_ID
} from './constants.ts';

// Steps where the patient is still being monitored show the aligner/monitoring (DM) column.
export const ALIGNER_COLUMN_STATUSES: ReadonlySet<string> = new Set([
    PENDING_MONITORING_START_STATUS_ID,
    TREATMENT_IN_PROGRESS_STATUS_ID,
    DM_VA_NEEDED_STATUS_ID,
    CLINICAL_VA_NEEDED_STATUS_ID,
    'Ref - 1. Ready for refinement'
]);

// Refinement-round steps and the clinical VA show the REFINEMENTS count.
// Includes 6.1 so it doesn't flicker off for one hop (6 -> 6.1 -> 7).
export const REFINEMENTS_COLUMN_STATUSES: ReadonlySet<string> = new Set([
    CLINICAL_VA_NEEDED_STATUS_ID,
    'Ref - 3. Submit refinement for design',
    'Ref - 5. Review refinement design',
    'Ref - 6. Create RDI',
    'Ref - 6.1. Pending refinement approval',
    'Ref - 7. Submit for manufacturing'
]);

// Steps worked against a manufacturer portal show which portal to open.
export const MANUFACTURER_COLUMN_STATUSES: ReadonlySet<string> = new Set([
    'Init - 1. Records under review',
    'Init - 2. Create in manufacturer',
    'Init - 3. Submit for design',
    'Init - 5. Review design',
    'Init - 9. Submit for manufacturing',
    'Init - 10.2. Submit for manufacturing',
    'Ref - 2.1. Refinement records under review',
    'Ref - 2.2. Create refinement in manufacturer',
    'Ref - 3. Submit refinement for design',
    'Ref - 5. Review refinement design',
    'Ref - 7. Submit for manufacturing',
    'Ret - 2.1. Retention records under review'
]);

export interface ExtraCaseColumns {
    showAlignerColumn: boolean;
    showManufacturerColumn: boolean;
    showManufacturerStatusColumn: boolean;
    showRefinementsColumn: boolean;
    showVaCountsColumn: boolean;
}

export function extraColumnsFor(statusId: string | null): ExtraCaseColumns {
    const has = (set: ReadonlySet<string>) => !!statusId && set.has(statusId);
    return {
        showAlignerColumn: has(ALIGNER_COLUMN_STATUSES),
        showManufacturerColumn: has(MANUFACTURER_COLUMN_STATUSES),
        showManufacturerStatusColumn: has(MANUFACTURER_STATUS_STATUSES),
        showRefinementsColumn: has(REFINEMENTS_COLUMN_STATUSES),
        showVaCountsColumn: statusId === DM_VA_NEEDED_STATUS_ID
    };
}
